import React, { useEffect, useState } from 'react';
import { useUnits } from 'hook/units/index';
import Layout from 'shared/component/Layout';
import UnitForm from 'shared/forms/UnitForm';
import { useParams } from 'react-router-dom';
import { useStyles } from './styles';
import { CircularProgress } from '@material-ui/core';
export default function HospitalEditPage() {
  const classes = useStyles();
  const { id } = useParams();
  const { data, loading, getOne, getUpdate, status } = useUnits();
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (id !== ':id') {
      getOne({ id });
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setTimeout(() => {
        setInitialValues(data);
      }, 750);
    }
  }, [data]);

  const formSubmit = (data) => {
    getUpdate({ id, data });
  };

  return (
    <Layout title="Hospitais" showToday backArrow>
      <>
        {initialValues ? (
          <UnitForm
            formSubmit={formSubmit}
            formInitialValues={initialValues}
            isLoading={loading}
            status={status}
            isEdit
          />
        ) : (
          <div className={classes.loading_container}>
            <CircularProgress color="primary" size={50} />
          </div>
        )}
      </>
    </Layout>
  );
}
